import { render, staticRenderFns } from "./SocialStreamConfig.vue?vue&type=template&id=2faecccc&lang=html"
import script from "./SocialStreamConfig.vue?vue&type=script&lang=ts"
export * from "./SocialStreamConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports